import { Box } from "@mui/material";
import useB2BTranslation from "../../../b2b-common/hooks/useB2BTranslation";
import useGetProducts from "../../hooks/useGetProducts";
import { generateClassName } from "../../../b2b-common/helpers";
import { TreeItem, TreeView } from "@mui/x-tree-view";
import { ChevronRight, ExpandMore } from "@mui/icons-material";
import ProductItem from "./ProductItem";
import { forwardRef, useImperativeHandle, useState } from "react";

const ProductsHierarchy = forwardRef(({ className = null, styles = {}, onProductSelect = null }, ref) => {
    const { t } = useB2BTranslation('b2b-users');
    const { productsData, fetchingProductsData, triggerRefresh } = useGetProducts();
    const [expanded, setExpanded] = useState([]);

    useImperativeHandle(ref, () => ({
        triggerRefresh
    }), [triggerRefresh]);

    const handleProductSelect = (node, event) => {
        event.stopPropagation();
        onProductSelect && onProductSelect(node);
    };

    const renderTree = (node) => {
        if (!node || !node.productId) {
            return null; // Add a check for undefined node or missing productId
        }

        const isBold = Array.isArray(node.childProducts) && node.childProducts.length > 0;
        const isProductParameterized = node.productParameterized;

        // Sort child products
        const sortedChildProducts = Array.isArray(node.childProducts)
            ? [
                ...node.childProducts.filter((child) => !child.childProducts || child.childProducts.length === 0),
                ...node.childProducts.filter((child) => child.childProducts && child.childProducts.length > 0),
            ]
            : [];

        return (
            <TreeItem
                key={node.productId.toString()}
                nodeId={node.productId.toString()}
                label={<ProductItem node={node} isBold={isBold} isProductParameterized={isProductParameterized} />}
                onDoubleClick={(event) => handleProductSelect(node, event)}
            >
                {sortedChildProducts.map(renderTree)}
            </TreeItem>
        );
    };

    return (
        <Box className={generateClassName('products-hierarchy', '', className)} gap={3} width={'100%'} style={styles.container}>
            {(fetchingProductsData && !productsData) && <p>{t('Fetching products data...')}</p>}
            {productsData && (
                <TreeView
                    defaultCollapseIcon={<ExpandMore />}
                    defaultExpandIcon={<ChevronRight />}
                    expanded={expanded}
                    onNodeToggle={(event, nodes) => setExpanded(nodes)}
                    className={'tree-view-container'}
                >
                    {renderTree(productsData[0])}
                </TreeView>
            )}
        </Box>
    );
});

export default ProductsHierarchy;